
export enum BANK_FORM_FIELD {
	DDA_TYPE = 'DdaType',
	ACCOUNT_NUMBER = 'AccountNumber',
	MASKED_ACCOUNT_NUMBER = 'maskedAccountNumber',
	MASKED_ROUTING_NUMBER = 'maskedRoutingNumber',
	ROUTING_NUMBER = 'RoutingNumber',
	BANK_NAME = 'BankName',
	IS_VERIFIED = 'bankAccountVerified',
	CURRENCY = 'Currency',
}

export enum BANK_FORM_FIELD_NAMES {
	DDA_TYPE = 'NEW_APPLICATION.LABEL.DDA_TYPE',
	ACCOUNT_NUMBER = 'NEW_APPLICATION.LABEL.ACCOUNT_NUMBER',
	ROUTING_NUMBER = 'NEW_APPLICATION.LABEL.ROUTING_NUMBER',
	BANK_NAME = 'NEW_APPLICATION.LABEL.BANK_NAME',
	IS_VERIFIED = 'NEW_APPLICATION.LABEL.IS_VERIFIED',
	CURRENCY = 'NEW_APPLICATION.LABEL.CURRENCY',
}

export type BankFieldsTypes = {
	[BANK_FORM_FIELD.DDA_TYPE]: string;
	[BANK_FORM_FIELD.ACCOUNT_NUMBER]: string;
	[BANK_FORM_FIELD.ROUTING_NUMBER]: string;
	[BANK_FORM_FIELD.MASKED_ACCOUNT_NUMBER]: string;
	[BANK_FORM_FIELD.MASKED_ROUTING_NUMBER]: string;
	[BANK_FORM_FIELD.BANK_NAME]: string;
	[BANK_FORM_FIELD.CURRENCY]: string;
	[BANK_FORM_FIELD.IS_VERIFIED]?: string | Date | boolean | null;
}

export type BankFieldsReturnTypes = {
	ddaType: string;
	accountNumber: string | null;
	routingNumber: string | null;
	maskedAccountNumber: string | null;
	maskedRoutingNumber: string | null;
	bankName: string;
	currency?: string;
	bankAccountVerified?: string | Date | boolean | null;
}

export const bankInitialValues: BankFieldsTypes = {
	[BANK_FORM_FIELD.DDA_TYPE]: '',
	[BANK_FORM_FIELD.ACCOUNT_NUMBER]: '',
	[BANK_FORM_FIELD.ROUTING_NUMBER]: '',
	[BANK_FORM_FIELD.MASKED_ACCOUNT_NUMBER]: '',
	[BANK_FORM_FIELD.MASKED_ROUTING_NUMBER]: '',
	[BANK_FORM_FIELD.BANK_NAME]: '',
	[BANK_FORM_FIELD.CURRENCY]: '',
	[BANK_FORM_FIELD.IS_VERIFIED]: false
};

export const getFormattedBankFormFields = (formikValues, data): BankFieldsReturnTypes => {
	const today = new Date().toUTCString();
	const date = data?.bankAccountInformation?.bankAccountVerified || today;
	const isVerified = formikValues?.[BANK_FORM_FIELD.IS_VERIFIED] ? date : null;
	return ({
		ddaType: formikValues?.[BANK_FORM_FIELD.DDA_TYPE] || null,
		accountNumber: formikValues?.[BANK_FORM_FIELD.ACCOUNT_NUMBER]|| null,
		routingNumber: formikValues?.[BANK_FORM_FIELD.ROUTING_NUMBER]|| null,
		maskedAccountNumber: formikValues?.[BANK_FORM_FIELD.MASKED_ACCOUNT_NUMBER]|| null,
		maskedRoutingNumber: formikValues?.[BANK_FORM_FIELD.MASKED_ROUTING_NUMBER]|| null,
		bankName: formikValues?.[BANK_FORM_FIELD.BANK_NAME]|| null,
		currency: formikValues?.[BANK_FORM_FIELD.CURRENCY] || null,
		bankAccountVerified: isVerified,
	});
};

export const convertBankFieldsToInitial = (data): BankFieldsTypes => ({
	[BANK_FORM_FIELD.DDA_TYPE]: data?.bankAccountInformation?.ddaType ?? '',
	[BANK_FORM_FIELD.ACCOUNT_NUMBER]: data?.bankAccountInformation?.accountNumber ?? '',
	[BANK_FORM_FIELD.MASKED_ACCOUNT_NUMBER]: data?.bankAccountInformation?.maskedAccountNumber ?? '',
	[BANK_FORM_FIELD.MASKED_ROUTING_NUMBER]: data?.bankAccountInformation?.maskedRoutingNumber ?? '',
	[BANK_FORM_FIELD.ROUTING_NUMBER]: data?.bankAccountInformation?.routingNumber ?? '',
	[BANK_FORM_FIELD.BANK_NAME]: data?.bankAccountInformation?.bankName ?? '',
	[BANK_FORM_FIELD.CURRENCY]: data?.bankAccountInformation?.currency ?? '',
	[BANK_FORM_FIELD.IS_VERIFIED]: !!data?.bankAccountInformation?.bankAccountVerified,
});

export const getFormattedBankData = (data): BankFieldsReturnTypes => ({
	ddaType: data?.bankAccountInformation?.ddaType,
	accountNumber: data?.bankAccountInformation?.accountNumber,
	routingNumber: data?.bankAccountInformation?.routingNumber,
	maskedAccountNumber: data?.bankAccountInformation?.maskedAccountNumber,
	maskedRoutingNumber: data?.bankAccountInformation?.maskedRoutingNumber,
	bankName: data?.bankAccountInformation?.bankName,
	currency: data?.bankAccountInformation?.currency,
	bankAccountVerified: data?.bankAccountInformation?.bankAccountVerified
});
